module.exports = __webpack_public_path__ + "media/app/components/CategoryNav/iconsNewDesign/124.ec622ff5.svg";